import React, { useRef } from 'react';

import Button from '@components/Button';
import PipelineMethodsView from '@components/experiments/pipelineMethods/PipelineMethodsView';
import PlutoErrorBoundary from '@components/PlutoErrorBoundary';

import useCopyToClipboard from '@hooks/useCopyToClipboard';

import { CopyIcon } from '@icons/custom/CopyIcon';

import Experiment from '@models/Experiment';

type Props = {
    experiment: Experiment;
};

const PipelineMethodsContent = ({ experiment }: Props) => {
    const pipelineMethodsRef = useRef<HTMLDivElement>(null);
    const { copyText, showCopySuccess, highlightText } = useCopyToClipboard({
        ref: pipelineMethodsRef,
        successTimeoutDuration: 3000,
    });

    return (
        <div>
            <PlutoErrorBoundary>
                <div ref={pipelineMethodsRef}>
                    <PipelineMethodsView experiment={experiment} />
                </div>
            </PlutoErrorBoundary>
            <div className="mt-4 flex justify-end">
                <Button
                    startIcon={<CopyIcon height={16} width={16} />}
                    color="primary"
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        highlightText();
                        copyText();
                    }}
                >
                    {showCopySuccess ? 'Copied!' : 'Copy'}
                </Button>
            </div>
        </div>
    );
};

export default PipelineMethodsContent;
